import { render, staticRenderFns } from "./HMSurvey.vue?vue&type=template&id=b156de3c&scoped=true&"
import script from "./HMSurvey.vue?vue&type=script&lang=js&"
export * from "./HMSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b156de3c",
  null
  
)

export default component.exports